/** Variante A do teste A/B: vídeo do produto na hero. */
import { createFileRoute } from "@tanstack/react-router";

import { FAQ, RoteiroAvaliacaoLP } from "@/components/roteiro/RoteiroAvaliacaoLP";


export const Route = createFileRoute("/roteiro-avaliacao-1")({
  head: () => ({
    meta: [
      { title: "Roteiro Prático de Avaliação Musculoesquelética | FEO" },
      {
        name: "description",
        content:
          "E-book + 5 aulas gravadas com certificado de 5h para estruturar sua avaliação musculoesquelética com clareza e segurança. Oferta exclusiva: R$37 (de R$97).",
      },
      { property: "og:title", content: "Roteiro Prático de Avaliação Musculoesquelética | FEO" },
      {
        property: "og:description",
        content: "O modelo de avaliação que vem transformando a rotina clínica dos nossos alunos. Por R$37,00.",
      },
      { property: "og:url", content: "https://fisioemortopedia.com.br/roteiro-avaliacao-1" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Roteiro Prático de Avaliação Musculoesquelética | FEO" },
      {
        name: "twitter:description",
        content: "O modelo de avaliação que vem transformando a rotina clínica dos nossos alunos. Por R$37,00.",
      },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/roteiro-avaliacao-1" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: RoteiroRouteHero,
});

function RoteiroRouteHero() {
  return <RoteiroAvaliacaoLP videoPlacement="hero" />;
}

